/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'

type Props = {
  show: boolean
  handleClose: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const LogInSuccessfully = ({show, handleClose}: Props) => {
  const {t} = useTranslation()

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered'
      show={show}
      onHide={handleClose}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2></h2>
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        <p>{t('AUTH.LOGIN_SUCCESS_REDIRECT')}</p>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {LogInSuccessfully}
